import React, { useEffect, useState } from 'react';
import { EnvelopeSimple, Phone, MapPin, Copy, Clock } from '@phosphor-icons/react';
import { useLocation } from 'react-router-dom';
export function Footer() {
  const [currentTime, setCurrentTime] = useState('');
  const location = useLocation();
  const isCaseStudyPage = location.pathname.includes('/case-study/');
  // Update time every minute
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      setCurrentTime(`${hours}:${minutes}`);
    };
    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, []);
  // Don't render the footer on case study pages
  if (isCaseStudyPage) {
    return null;
  }
  return <footer className="bg-black text-white py-12 sm:py-16 px-6 sm:px-12 md:px-16 lg:px-24 relative" id="contact" data-id="element-245">
      <div className="container mx-auto" data-id="element-246">
        {/* Three column layout with improved visual balance */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 sm:gap-12 mb-10 sm:mb-12" data-id="element-247">
          {/* Column 1: Contact info with icons */}
          <div data-id="element-248">
            <h3 className="text-xs mb-5 uppercase text-white/60" style={{
            fontFamily: "'Ronzino', sans-serif",
            fontWeight: 500,
            letterSpacing: '0.2em'
          }} data-id="element-249">
              Contact
            </h3>
            <div className="flex items-center mb-4 group min-h-[44px] sm:min-h-0" data-id="element-250">
              <EnvelopeSimple className="w-4 h-4 mr-3 text-gray-400" data-id="element-251" />
              <a href="mailto:mateo.cohen9@gmail.com" className="text-white hover:text-gray-400 transition-colors flex items-center text-sm leading-relaxed py-2 sm:py-0" style={{
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }} data-id="element-252">
                <span data-id="element-253">mateo.cohen9@gmail.com</span>
                <Copy className="w-3 h-3 ml-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-254" />
              </a>
            </div>
            <div className="flex items-center group min-h-[44px] sm:min-h-0" data-id="element-255">
              <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 mr-3 text-gray-400" data-id="element-256">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-257"></path>
                <rect x="2" y="9" width="4" height="12" data-id="element-258"></rect>
                <circle cx="4" cy="4" r="2" data-id="element-259"></circle>
              </svg>
              <a href="https://www.linkedin.com/in/mateocohen/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-400 transition-colors text-sm py-2 sm:py-0" style={{
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }} data-id="element-260">
                linkedin.com/in/mateocohen
              </a>
            </div>
          </div>
          {/* Column 2: Location and time */}
          <div data-id="element-261">
            <h3 className="text-xs mb-5 uppercase text-white/60" style={{
            fontFamily: "'Ronzino', sans-serif",
            fontWeight: 500,
            letterSpacing: '0.2em'
          }} data-id="element-262">
              Location
            </h3>
            <div className="flex items-start mb-4" data-id="element-263">
              <MapPin className="w-4 h-4 mr-3 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-264" />
              <div className="text-sm leading-relaxed" style={{
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }} data-id="element-265">
                <p className="mb-0.5" data-id="element-266">Cleveland, OH</p>
                <p data-id="element-267">Pittsburgh, PA</p>
              </div>
            </div>
            <div className="flex items-center mt-4" data-id="element-268">
              <Clock className="w-4 h-4 mr-3 text-gray-400" data-id="element-269" />
              <div data-id="element-270">
                <p className="text-gray-400 text-xs mb-1" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-271">
                  My current time
                </p>
                <p className="text-sm" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-272">
                  {currentTime}{' '}
                  <span className="text-gray-400" data-id="element-273">Eastern (NYC)</span>
                </p>
              </div>
            </div>
          </div>
          {/* Column 3: Social links - LinkedIn, YouTube and Resume */}
          <div data-id="element-274">
            <h3 className="text-xs mb-5 uppercase text-white/60" style={{
            fontFamily: "'Ronzino', sans-serif",
            fontWeight: 500,
            letterSpacing: '0.2em'
          }} data-id="element-275">
              Connect
            </h3>
            <div className="grid grid-cols-3 gap-3 sm:gap-4" data-id="element-276">
              <a href="https://docs.google.com/document/d/1XmUDOfp7By_54KFbz9PI8GnRCbHTbtUHlIfyEodo_hE/edit?usp=sharing" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center p-2 sm:p-3 border border-gray-700 rounded-md hover:border-white transition-colors group" data-id="element-277">
                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-white transition-colors" data-id="element-278">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" data-id="element-279"></path>
                  <polyline points="14 2 14 8 20 8" data-id="element-280"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13" data-id="element-281"></line>
                  <line x1="16" y1="17" x2="8" y2="17" data-id="element-282"></line>
                  <polyline points="10 9 9 9 8 9" data-id="element-283"></polyline>
                </svg>
                <span className="text-xs mt-1 text-gray-400 group-hover:text-white transition-colors" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-284">
                  Résumé
                </span>
              </a>
              <a href="https://www.linkedin.com/in/mateocohen/" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center p-2 sm:p-3 border border-gray-700 rounded-md hover:border-white transition-colors group" data-id="element-285">
                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-white transition-colors" data-id="element-286">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-287"></path>
                  <rect x="2" y="9" width="4" height="12" data-id="element-288"></rect>
                  <circle cx="4" cy="4" r="2" data-id="element-289"></circle>
                </svg>
                <span className="text-xs mt-1 text-gray-400 group-hover:text-white transition-colors" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-290">
                  LinkedIn
                </span>
              </a>
              <a href="https://www.youtube.com/@somedesignerguy" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center p-2 sm:p-3 border border-gray-700 rounded-md hover:border-white transition-colors group" data-id="element-291">
                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-white transition-colors" data-id="element-292">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" data-id="element-293"></path>
                  <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" data-id="element-294"></polygon>
                </svg>
                <span className="text-xs mt-1 text-gray-400 group-hover:text-white transition-colors" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-295">
                  YouTube
                </span>
              </a>
            </div>
          </div>
        </div>
        {/* Footer bottom - copyright only, with extra padding for AI/FAQ buttons */}
        <div className="flex flex-col md:flex-row justify-center items-center pt-6 pb-16 border-t border-white/10 text-gray-400 text-xs tracking-wider" data-id="element-296">
          <p style={{
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-297">
            Copyright © 2026 Mateo Cohen
          </p>
        </div>
      </div>
    </footer>;
}